import { useState, useEffect } from 'react';
import { X, AlertTriangle, Tag } from 'lucide-react';

export default function NotificacaoPrecoZerado({ notificacao, onClose }) {
  const [tempoRestante, setTempoRestante] = useState(60);
  const d = notificacao.dados;

  useEffect(() => {
    const t = setInterval(() => {
      setTempoRestante(prev => {
        if (prev <= 1) { clearInterval(t); onClose(); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [onClose]);

  const funcionarioNome = d.funcionario
    ? d.funcionario.replace(/^\d+ - /, '')
    : '—';

  return (
    <div className="w-96 bg-white rounded-xl shadow-2xl border-2 border-orange-400 overflow-hidden animate-slide-in">
      {/* Header */}
      <div className="bg-gradient-to-r from-orange-500 to-red-500 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-6 h-6 text-orange-500" />
          </div>
          <div className="text-white">
            <h3 className="font-bold text-base leading-tight">Preço Zerado Detectado!</h3>
            <p className="text-xs opacity-80">Orçamento de Venda</p>
          </div>
        </div>
        <button onClick={onClose} className="text-white hover:bg-white/20 rounded-lg p-1.5 transition-colors">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Conteúdo */}
      <div className="p-4 space-y-3">
        {/* Produto */}
        <div className="bg-orange-50 rounded-lg p-3 border border-orange-200">
          <div className="flex items-center gap-2 text-orange-700 text-xs mb-1">
            <Tag className="w-3.5 h-3.5" />
            Produto
          </div>
          <p className="font-bold text-gray-900 text-2xl">Cód. {d.codigo_produto}</p>
          {d.funcionario && (
            <p className="text-xs text-gray-500 mt-1">Operador: {funcionarioNome}</p>
          )}
        </div>

        {/* Tabelas zeradas */}
        <div className="space-y-1">
          <p className="text-xs font-medium text-gray-600">Tabelas com preço R$ 0,00:</p>
          <div className="flex flex-wrap gap-1.5">
            {(d.tabelas || []).map((t) => (
              <span
                key={t.ordem}
                className="bg-red-100 text-red-700 text-xs font-medium px-2 py-0.5 rounded-full border border-red-200"
              >
                {t.nome}
              </span>
            ))}
          </div>
        </div>

        {/* Barra de progresso */}
        <div className="w-full bg-gray-100 rounded-full h-1.5">
          <div
            className="bg-orange-400 h-1.5 rounded-full transition-all duration-1000 ease-linear"
            style={{ width: `${(tempoRestante / 60) * 100}%` }}
          />
        </div>
        <p className="text-xs text-gray-400 text-center">Fechará em {tempoRestante}s</p>
      </div>
    </div>
  );
}
